import instance from '../config/axios';
import { ReactSelectOptionProp } from '../interface/interface';
import { stringify } from 'qs';
import { calculateOutOfStockEnum } from '../utils/outOfStockStatus';
import { Endpoints } from './endPoints';

type GetGuestAccessories = (
  brand: Array<ReactSelectOptionProp>,
  cart?: any[],
) => Promise<Array<any> | null>;

export const getGuestAccessories: GetGuestAccessories = async (brand, cart) => {
  try {
    const result = await instance({
      url: `${Endpoints.GET_ACCESSORIES}?${stringify({
        sort: { sortByBrand: brand?.map((e) => e.value) },
      })}`,
      method: 'GET',
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const quantityCheckedAccessories = result?.data?.map((product: any) => {
      const cartItem = cart?.find(
        (item: any) => `${item.product_id}` === `${product.product_code}`,
      );
      const orderedQuantity = cartItem?.quantity ?? 0;

      return {
        ...product,
        orderedQuantity,
        outOfStock: calculateOutOfStockEnum(product, orderedQuantity),
      };
    });

    return quantityCheckedAccessories;
  } catch (error) {
    console.error('Error fetching guest accessories:', error);
    return null;
  }
};
